import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-Refresh",
  "use": "svg-icon-Refresh-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-Refresh\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.6 5.6a4 4 0 0 1 4-4c.98 0 1.925.366 2.652 1.025L6.399 4.321 12 5.701 11.12 0 9.441 1.536A5.566 5.566 0 0 0 5.599 0a5.6 5.6 0 1 0 0 11.198c2.12 0 4.058-1.2 5.004-3.097l-1.44-.72c-.658 1.31-1.998 2.218-3.564 2.218a4 4 0 0 1-4-4z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol